export const API_BASE_URL = "https://api.themoviedb.org/3/";
export const API_KEY = "af04cfe94f70bc39140651e28dd6c911";
